<template>
  <div class="caseDetail">
    <viewHeader></viewHeader>
    <div class="content">
      <el-card
        class="box-card"
        shadow="never"
        v-loading="loading"
        :element-loading-text="loadingText"
      >
        <el-row :gutter="30" class="fullTitle" slot="header">
          <el-col :span="14" class="title clearfix">
            <img src="../assets/img/icon7.png" alt="" class="L" />
            <span class="L">{{ detailData.title_en }}</span>
          </el-col>
          <el-col
            :span="5"
            class="YXYZ clearfix"
            v-if="detailData.impact_factor && detailData.impact_factor !== ''"
          >
            <img src="../assets/img/icon6.png" alt="" class="L" />
            <span class="L">影响因子：{{ detailData.impact_factor }}</span>
          </el-col>
          <el-col
            :span="4"
            class="RGBZ clearfix"
            v-if="detailData.has_manual_curation !== 0"
          >
            <img src="../assets/img/icon5.png" alt="" class="L" />
            <span class="L"
              >人工标注：{{ detailData.has_manual_curation }}</span
            >
          </el-col>
        </el-row>
        <el-row class="clearfix actionRow">
          <p class="R action clearfix">
            <a
              href="javascript:;"
              class="similar L"
              @click="showSimilarCase"
              >相似病例</a
            >
            <a
              href="javascript:;"
              class="original L"
              @click="showOriginText(detailData.pmid, detailData.full_link)"
              >查看原文</a
            >
            <a href="javascript:;" class="translate L" @click="translateKey"
              >翻译</a
            >
            <a
              href="javascript:;"
              class="L"
              :class="caseData.is_collected ? 'collectionTrue' : 'collection'"
              @click="collection"
              >{{ caseData.is_collected ? "已收藏" : "收藏" }}</a
            >
            <a
              href="javascript:;"
              class="L download"
              @click="pptDialog = true"
              >自动生成PPT</a
            >
            <!-- <a href="javascript:;" class="share L">分享</a> -->
          </p>
        </el-row>
        <div class="case-message-box">
          <h3>病例信息</h3>
          <div class="case-message">
            <el-avatar :size="48" :src="caseData.avatar"></el-avatar>
            <div class="patient-message">
              <p><span><em class="title">患者编号：</em>{{ caseData.patient_uid }}</span></p>
              <p><span><em class="title">性别：</em>{{ caseData.gender ? '男' : '女' }}</span><span><em class="title">年龄：</em>{{ caseData.age }}岁</span></p>
              <!-- 疾病与人群 -->
              <p v-if="caseData.keywords && caseData.keywords['Diseases & conditions'].length > 0">
                <em class="title">疾病与人群：</em>
                <template v-if="!caseData.translate">
                  <em v-for="(words, wordsIndex) in caseData.keywords['Diseases & conditions']" :key="words + '-' + wordsIndex">{{ `${words.keyword_en}${wordsIndex < caseData.keywords['Diseases & conditions'].length - 1 ? '、' : ''}` }} </em>
                </template>
                <template v-if="caseData.translate">
                  <em v-for="(words, wordsIndex) in caseData.keywords['Diseases & conditions']" :key="words + '-' + wordsIndex">{{ `${words.keyword_cn}${wordsIndex < caseData.keywords['Diseases & conditions'].length - 1 ? '、' : ''}` }} </em>
                </template>
              </p>
              <!-- 干预与操作 -->
              <p v-if="caseData.keywords && caseData.keywords['Interventions'].length > 0">
                <em class="title">干预与操作：</em>
                <template v-if="!caseData.translate">
                  <em v-for="(words, wordsIndex) in caseData.keywords['Interventions']" :key="words + '-' + wordsIndex">{{ `${words.keyword_en}${wordsIndex < caseData.keywords['Interventions'].length - 1 ? '、' : ''}` }} </em>
                </template>
                <template v-if="caseData.translate">
                  <em v-for="(words, wordsIndex) in caseData.keywords['Interventions']" :key="words + '-' + wordsIndex">{{ `${words.keyword_cn}${wordsIndex < caseData.keywords['Interventions'].length - 1 ? '、' : ''}` }} </em>
                </template>
              </p>
              <!-- 国家与地区 -->
              <p v-if="caseData.keywords && caseData.keywords['Geographical regions'].length > 0">
                <em class="title">国家与地区：</em>
                <template v-if="!caseData.translate">
                  <em v-for="(words, wordsIndex) in caseData.keywords['Geographical regions']" :key="words + '-' + wordsIndex">{{ `${words.keyword_en}${wordsIndex < caseData.keywords['Geographical regions'].length - 1 ? '、' : ''}` }} </em>
                </template>
                <template v-if="caseData.translate">
                  <em v-for="(words, wordsIndex) in caseData.keywords['Geographical regions']" :key="words + '-' + wordsIndex">{{ `${words.keyword_cn}${wordsIndex < caseData.keywords['Geographical regions'].length - 1 ? '、' : ''}` }} </em>
                </template>
              </p>
              <p><span><em class="title">病例介绍：</em><em v-html="!caseData.translate ? caseData.patient_en : caseData.patient_cn"></em></span></p>
            </div>
          </div>
        </div>
        <div class="textInfo">
          <h3>文献信息</h3>
          <el-row>
            <el-col :span="1.5"><span>期刊：</span></el-col>
            <el-col :span="20">{{ detailData.journal_name }}</el-col>
          </el-row>
          <el-row>
            <el-col :span="24"
              ><span>页码：</span>{{ detailData.pages }}</el-col
            >
          </el-row>
          <el-row>
            <el-col :span="24"><span>PMID：</span>{{ detailData.pmid }}</el-col>
          </el-row>
          <el-row>
            <el-col :span="24"
              ><span>发表时间：</span>{{ detailData.pubdate_show || "" }}</el-col
            >
          </el-row>
          <el-row>
            <el-col :span="24">
              <span>作者：</span>
              <em v-for="(item, index) in detailData['author']" :key="index"
                >{{ item
                }}<i v-if="index + 1 < detailData['author'].length"> 、</i></em
              >
            </el-col>
          </el-row>
          <el-row
            v-if="
              detailData.keyword_categories &&
              detailData.keyword_categories['Diseases']
            "
          >
            <el-col :span="1.5"><span>疾病：</span></el-col>
            <el-col :span="20">
              <em
                v-for="(disease, diseaseIndex) in detailData.keyword_categories[
                  'Diseases'
                ]"
                :key="diseaseIndex"
                >{{ disease[0] + "(" + disease[1] + ")"
                }}<i
                  v-if="
                    diseaseIndex + 1 <
                    detailData.keyword_categories['Diseases'].length
                  "
                >
                  、</i
                ></em
              >
            </el-col>
          </el-row>
          <el-row
            v-if="
              detailData.keyword_categories &&
              detailData.keyword_categories['Drugs and Chemicals']
            "
          >
            <el-col :span="1.5"><span>药品：</span></el-col>
            <el-col :span="20">
              <em
                v-for="(drug, drugIndex) in detailData.keyword_categories[
                  'Drugs and Chemicals'
                ]"
                :key="drugIndex"
                >{{ drug[0] + "(" + drug[1] + ")"
                }}<i
                  v-if="
                    drugIndex + 1 !==
                    detailData.keyword_categories['Drugs and Chemicals'].length
                  "
                >
                  、</i
                ></em
              >
            </el-col>
          </el-row>
          <el-row
            v-if="
              detailData.keyword_categories &&
              detailData.keyword_categories['Geographic Locations']
            "
          >
            <el-col :span="24">
              <span>地理位置：</span>
              <em
                v-for="(location, locationIndex) in detailData
                  .keyword_categories['Geographic Locations']"
                :key="locationIndex"
                >{{ location[0] + "(" + location[1] + ")"
                }}<i
                  v-if="
                    locationIndex + 1 !==
                    detailData.keyword_categories['Geographic Locations'].length
                  "
                >
                  、</i
                ></em
              >
            </el-col>
          </el-row>
          <el-row
            v-if="
              detailData.keyword_categories &&
              detailData.keyword_categories['Persons']
            "
          >
            <el-col :span="24">
              <span>人群：</span>
              <em
                v-for="(person, personIndex) in detailData.keyword_categories[
                  'Persons'
                ]"
                :key="personIndex"
                >{{ person[0] + "(" + person[1] + ")"
                }}<i
                  v-if="
                    personIndex + 1 !==
                    detailData.keyword_categories['Persons'].length
                  "
                >
                  、</i
                ></em
              >
            </el-col>
          </el-row>
          <el-row
            v-if="
              detailData.keyword_categories &&
              detailData.keyword_categories['Oragnisms']
            "
          >
            <el-col :span="24">
              <span>生物种类：</span>
              <em
                v-for="(oragnisms, oragnismsIndex) in detailData
                  .keyword_categories['Oragnisms']"
                :key="oragnismsIndex"
                >{{ oragnisms[0] + "(" + oragnisms[1] + ")"
                }}<i
                  v-if="
                    oragnismsIndex + 1 !==
                    detailData.keyword_categories['Oragnisms'].length
                  "
                >
                  、</i
                ></em
              >
            </el-col>
          </el-row>
          <el-row
            v-if="
              detailData.keyword_categories &&
              detailData.keyword_categories[
                'Analytical, Diagnostic and Therapeutic Techniques and Equipment'
              ]
            "
          >
            <el-col :span="1.5"><span>实验技术与仪器：</span></el-col>
            <el-col :span="20">
              <em
                v-for="(experiment, experimentIndex) in detailData
                  .keyword_categories[
                  'Analytical, Diagnostic and Therapeutic Techniques and Equipment'
                ]"
                :key="experimentIndex"
                >{{ experiment[0] + "(" + experiment[1] + ")"
                }}<i
                  v-if="
                    experimentIndex + 1 !==
                    detailData.keyword_categories[
                      'Analytical, Diagnostic and Therapeutic Techniques and Equipment'
                    ].length
                  "
                >
                  、</i
                ></em
              >
            </el-col>
          </el-row>
          <el-row
            v-if="
              detailData.keyword_categories &&
              detailData.keyword_categories['Biological Sciences']
            "
          >
            <el-col :span="1.5"><span>生物科学关键词：</span></el-col>
            <el-col :span="20">
              <em
                v-for="(biological, biologicalIndex) in detailData
                  .keyword_categories['Biological Sciences']"
                :key="biologicalIndex"
                >{{ biological[0] + "(" + biological[1] + ")"
                }}<i
                  v-if="
                    biologicalIndex + 1 !==
                    detailData.keyword_categories['Biological Sciences'].length
                  "
                >
                  、</i
                ></em
              >
            </el-col>
          </el-row>
          <el-row
            v-if="
              detailData.keyword_categories &&
              detailData.keyword_categories['Health Care']
            "
          >
            <el-col :span="1.5"><span>医疗研究关键词：</span></el-col>
            <el-col :span="20">
              <em
                v-for="(health, healthIndex) in detailData.keyword_categories[
                  'Health Care'
                ]"
                :key="healthIndex"
                >{{ health[0] + "(" + health[1] + ")"
                }}<i
                  v-if="
                    healthIndex + 1 !==
                    detailData.keyword_categories['Health Care'].length
                  "
                >
                  、</i
                ></em
              >
            </el-col>
          </el-row>
          <el-row
            v-if="
              detailData.interpr_unstruct &&
              detailData.interpr_unstruct.length === []
            "
          >
            <el-col :span="24" class="clearfix">
              <span class="L">文章解读：</span>
              <ul class="L">
                <li
                  v-for="(article, articleIndex) in detailData.interpr_unstruct"
                  :key="articleIndex"
                >
                  {{ index + 1 + "、" + article }}
                </li>
              </ul>
            </el-col>
          </el-row>
          <el-row
            v-if="
              detailData.interpr_struct &&
              detailData.interpr_struct.length === []
            "
          >
            <el-col :span="24">
              <span>结构化结论：</span>
              <table>
                <tr>
                  <th>主体类别</th>
                  <th>主体</th>
                  <th>特征</th>
                  <th>描述</th>
                  <th>定性描述</th>
                </tr>
                <col style="width: 15%" />
                <col style="width: 15%" />
                <col style="width: 15%" />
                <col style="width: 30%" />
                <col style="width: 25%" />
                <tbody>
                  <tr
                    v-for="(item, index) in detailData.interpr_struct"
                    :key="index"
                  >
                    <td v-for="(item1, index1) in item" :key="index1">
                      {{ item1 }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </el-col>
          </el-row>
          <el-row
            v-if="
              detailData.key_information &&
              detailData.key_information[0] &&
              detailData.key_information[0][1] !== ''
            "
          >
            <el-col :span="2.5"><span>研究背景：</span></el-col>
            <el-col :span="21">{{ detailData.key_information[0][1] }}</el-col>
          </el-row>
          <el-row
            v-if="
              detailData.key_information &&
              detailData.key_information[1] &&
              detailData.key_information[1][1] !== ''
            "
          >
            <el-col :span="2.5"><span>研究目标：</span></el-col>
            <el-col :span="21">{{ detailData.key_information[1][1] }}</el-col>
          </el-row>
          <el-row
            v-if="
              detailData.key_information &&
              detailData.key_information[2] &&
              detailData.key_information[2][1] !== ''
            "
          >
            <el-col :span="2.5"><span>研究方法：</span></el-col>
            <el-col :span="21">{{ detailData.key_information[2][1] }}</el-col>
          </el-row>
          <el-row
            v-if="
              detailData.key_information &&
              detailData.key_information[3] &&
              detailData.key_information[3][1] !== ''
            "
          >
            <el-col :span="2.5"><span>研究结果：</span></el-col>
            <el-col :span="21">{{ detailData.key_information[3][1] }}</el-col>
          </el-row>
          <el-row
            v-if="
              detailData.key_information &&
              detailData.key_information[4] &&
              detailData.key_information[4][1] !== ''
            "
          >
            <el-col :span="2.5"><span>研究结论：</span></el-col>
            <el-col :span="21">{{ detailData.key_information[4][1] }}</el-col>
          </el-row>
          <el-row v-if="detailData.important_message && detailData.important_message.length != 0">
            <el-col :span="24"><span>重点信息：</span></el-col>
            <el-col :span="24" style="margin-top: 10px">
              <p
                style="margin-top: 10px"
                v-for="(item, index) in detailData.important_message" :key="'重点信息' + index">
                {{ `● ${item}` }}
              </p>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24"><span>文献摘要：</span></el-col>
            <el-col :span="24" style="margin-top: 10px">
              <p
                style="margin-top: 10px"
                v-for="(item, index) in detailData.abstract_en" :key="index">
                {{ item }}
              </p>
            </el-col>
          </el-row>
        </div>
      </el-card>
    </div>
    <!-- ppt下载选择框 -->
    <el-dialog
      title="PPT下载"
      :visible.sync="pptDialog"
      width="360px"
      top='20vh'
      custom-class='pptDialog'
      :close-on-click-modal='false'
      >
      <div class="pptDialogContent">
        <div class="item">
          <span class="label">语言</span>
          <div class="lanSelect">
            <div class="selectItem" :class="{lanBtn : selectPPTLan == 'en'}" @click="switchLan('en')">英文</div>
            <div class="selectItem" :class="{lanBtn : selectPPTLan == 'cn'}" @click="switchLan('cn')">中文</div>
          </div>
        </div>
        <!-- <div class="item">
          <span class="label">形式</span>
          <div class="typeSelect">
            <el-radio-group v-model="selectType" size="small" @change='switchType'>
              <el-radio-button label="full" >完整</el-radio-button>
              <el-radio-button label="singlePage">单页</el-radio-button>
              <el-radio-button label="fullTranslate">全文翻译</el-radio-button>
            </el-radio-group>
          </div>
        </div> -->
        <div class="item" v-show="selectType != 'fullTranslate'">
          <span class="label">模版</span>
          <el-select class="select" v-model="selectTemplate" placeholder="请选择" size='small'>
            <el-option
              v-for="item in pptTemplate"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="templateView" v-show="selectType != 'fullTranslate'">
          <img class="preview" :src="templateMap[selectTemplate]" alt="">
        </div>
        <!-- <div class="templateView">
          <el-checkbox v-model="isDownLoadWord">同时下载文献全文中文翻译</el-checkbox>
        </div> -->
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" size='small' :loading='pptLoading' @click="downLoadCasePPT">{{downLoadText}}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { md5 } from "md5js";
import viewHeader from "./viewHeader";
import { caseDetail, caseCollect, fullText, translateInfo, downLoadCase, caseTranslate } from "../service/getData";
import { webTrackerEvent,webTracker } from "../utils/tracker";
import { baseURL } from '../config/request'
import axios from 'axios'
export default {
  name: "caseDetail",
  PMID: "", // 文献pmid
  components: {
    viewHeader,
  },
  data() {
    return {
      loading: false,
      loadingText : '拼命加载中',
      detailData: [], // 文献详情
      PMID: "",
      secret: "4ede4aafbzd51cbz3e32bzb781bzee9813d17154", // 秘钥
      clientId: "zeta", // 客户端id
      isTranslate: false, // 是否已经翻译了
      title: "",
      abstract_en: "",
      key_information: "",
      important_en: "",
      token: window.localStorage.getItem("PUBMEDSEARCHTOKEN"),
      openid: window.localStorage.getItem("PUBMEDSEARCHOPENID"),
      pptDialog : false,// ppt下载弹框
      pptLoading : false,
      downLoadText : '确认下载',
      selectPPTLan : 'en',// 选择的语言
      selectType:'full',// 选择的形式 （完整/单页/全文翻译）
      selectTemplate : 'zeta_cr_template_02',// 选择的模版
      pptTemplate:[
        {label:'暗灰纹理',value:'zeta_cr_template_02'},
        {label:'深海穹顶',value:'zeta_cr_template_09'},
        {label:'插画风格',value:'zeta_cr_template_08'},
        {label:'温暖渐变',value:'zeta_cr_template_01'},
        {label:'蓝色简约',value:'zeta_cr_template_04'},
        {label:'潮流暗黑',value:'zeta_cr_template_07'},
        {label:'新拟态风',value:'zeta_cr_template_06'},
        {label:'酸性镭射',value:'zeta_cr_template_03'},
        {label:'暖色弥散',value:'zeta_cr_template_05'}
      ],
      singlePageTemplat:[
        {label:'学术蓝',value:'zeta_leaflet_template_2'},
        {label:'活力紫',value:'zeta_leaflet_template_1'},
      ],
      templateMap:{
        'zeta_cr_template_01' : require('../assets/img/case/zeta_cr_template_01.png'),
        'zeta_cr_template_02' : require('../assets/img/case/zeta_cr_template_02.png'),
        'zeta_cr_template_03' : require('../assets/img/case/zeta_cr_template_03.png'),
        'zeta_cr_template_04' : require('../assets/img/case/zeta_cr_template_04.png'),
        'zeta_cr_template_05' : require('../assets/img/case/zeta_cr_template_05.png'),
        'zeta_cr_template_06' : require('../assets/img/case/zeta_cr_template_06.png'),
        'zeta_cr_template_07' : require('../assets/img/case/zeta_cr_template_07.png'),
        'zeta_cr_template_08' : require('../assets/img/case/zeta_cr_template_08.png'),
        'zeta_cr_template_09' : require('../assets/img/case/zeta_cr_template_09.png')
      },
      isDownLoadWord:false,// 是否下载word
      patientUid: '',
      caseData: {}, // 病例信息
      currentPageUrl: '', // 当前页面url
      searchType: ''
    };
  },
  methods: {
    // 获取病例信息
    async getCaseDetail() {
      let res = await caseDetail(this.patientUid);
      if (res && res.data.status === 0) {
        res.data.data.patient_en = res.data.data.patient_en.replace(/\n/g, '<br/>');
        // res.data.data.patient_cn = res.data.data.patient_cn.replace(/\n/g, '<br/>');
        res.data.data.patient_cn = "";
        if (res.data.data.gender) {
          res.data.data.avatar = require('../assets/img/female.png')
        } else {
          res.data.data.avatar = require('../assets/img/male.png')
        }
        this.caseData = res.data.data;
        this.caseData['translate'] = false;
      } else {
        this.caseData = {}
      }
    },
    /**
     * 选择语言
     */
    switchLan(value){
      this.selectPPTLan = value;
      // if(value == 'en') {
      //   this.selectType = 'full'
      // }
    },
    /**
     * 选择形式
     */
    // switchType(value){
    //   this.selectType = value;
    // },
    // 下载病例ppt
    downLoadCasePPT(){
      this.pptLoading = true;
      this.downLoadText = '正在下载'
      let params = {
        patient_uid : this.caseData.patient_uid,
        model : this.selectTemplate + '.pptx',
        language : this.selectPPTLan
      }
      let token = localStorage.getItem('PUBMEDSEARCHTOKEN');
      let url = `${baseURL}${downLoadCase}`;

      axios.get(`${url}`,{
        params:params,
        responseType:'blob',
        headers:{
          Authorization : token
        }
      }).then(async res => {
        if(res.headers['content-type'] == 'application/json') {
          this.$alert('目前PPT转换服务繁忙，请稍后重试', '提示', {
            confirmButtonText: '确定',
            type:'warning',
            callback: action => {
              this.pptDialog = false;
            }
          });
          return;
        }
        const fileName = decodeURI(res.headers.filename);
        const blob = new Blob([res.data], { type: 'application/octet-stream' });
        this._saveBlob(blob,fileName);

        // log appen by qinrui 2023-07-26
        let Logger = webTrackerEvent();
        Logger.push("eventType", "downloadCasePPT");
        Logger.push("timeStamp", new Date().getTime());
        Logger.push('token', token);
        Logger.push("openid", this.openid);
        Logger.push("patientUid", this.caseData.patient_uid);
        Logger.push("search_type", this.selectTemplate + '.pptx');
        Logger.push("language", this.selectPPTLan);
        Logger.push("pageUrl", window.location.href);
        Logger.logger()
        
        this.pptDialog = false;

      })
      .catch(error => {
        this.$alert('目前PPT转换服务繁忙，请稍后重试', '提示', {
          confirmButtonText: '确定',
          type:'warning',
          callback: action => {
            this.pptDialog = false;
          }
        });
        let Logger = webTracker();
        Logger.push('userHeadImg', window.localStorage.getItem('PUMMEDSEARCHHEADIMG'));
        Logger.push('userName', window.localStorage.getItem('PUMMEDSEARCHUSERNAME'));
        Logger.push('response_error_code', error.response.status);
        Logger.push('response_error_config', JSON.stringify(error.response.config));
        Logger.logger()
        return;
        // console.log(JSON.stringify(error));
      })
      .finally(() => {
        this.pptLoading = false;
        this.downLoadText = '确认下载';
      });
    },
    /**
     * 保存文件流
     */
    _saveBlob(blob,fileName){

      if(window.navigator&&window.navigator.msSaveOrOpenBlob) {
          // 兼容IE/Edge
        window.navigator.msSaveOrOpenBlob(blob,fileName)
      } else {
        let url = URL.createObjectURL(blob);
        const elink = document.createElement('a');
        elink.download = fileName;
        elink.style.display = 'none';
        elink.href = url;
        document.body.appendChild(elink);
        elink.click();
        URL.revokeObjectURL(url);
        document.body.removeChild(elink);
      }

    },
    async getFullText() {
      this.loading = true;
      const res = await fullText(this.PMID);
      this.loading = false;
      if (res.data.status === 0) {
        // if (res.data.data["pubdate_show"]) {
        //   const date = res.data.data["pubdate_show"].substring(0, 10);
        //   res.data.data["pubdate_show"] = date;
        // }
        this.title = res.data.data["title_en"];
        this.abstract_en = res.data.data["abstract_en"];
        this.key_information = res.data.data["key_information"];
        this.important_en = res.data.data["important_message"];
        this.detailData = res.data.data;
      } else {
        this.loading = false;
      }
    },
    // 翻译病例信息
    async translateCaseText() {
      const { patient_uid, patient_cn } = this.caseData;
      if (this.caseData.translate) {
        this.caseData.translate = false
      } else {
        if(patient_cn) {
          this.caseData.translate = true
        } else {
          const params = {
            patient_uid
          }
          const res = await caseTranslate(params);
          if(res && res.data && res.data.status == 0) {
            const { patient_cn } = res.data.data;
            this.caseData.patient_cn = patient_cn;
            this.caseData.translate = true
          }
        }
      }
    },
    // 翻译重点信息
    async translateKey() {
      this.loading = true;
      this.translateCaseText();
      let Logger = webTrackerEvent();
      if (this.isTranslate) {
        this.loading = false;
        this.detailData["title_en"] = this.title;
        this.detailData["key_information"] = this.key_information;
        this.detailData["abstract_en"] = this.abstract_en;
        this.detailData["important_message"] = this.important_en;
        this.isTranslate = false;

        Logger.push("page_url", window.location.href);
        Logger.push("language", "en_key");
        Logger.push("action", "translate");
        Logger.push("pmid", this.PMID);
        Logger.push("token", this.token);
        Logger.push("openid", this.openid);
        Logger.logger();
        return;
      }
      let ts = new Date().getTime();
      let tokenStr = `${this.clientId}.bz${ts}.bz${this.PMID}.bz${this.secret}`;
      let token = md5(tokenStr, 32);
      const params = {
        client_id: this.clientId,
        ts: Number(ts),
        pmid: String(this.PMID),
        types: "cn_key",
        token: token,
      };
      const res = await translateInfo(params);

      Logger.push("page_url", window.location.href);
      Logger.push("action", "translate");
      Logger.push("language", "cn_key");
      Logger.push("pmid", this.PMID);
      Logger.push("token", this.token);
      Logger.push("openid", this.openid);
      Logger.logger();

      if (res.data.status == 0) {
        this.detailData.title_en = res.data.data.title;
        this.detailData.key_information = res.data.data.sentence;
        this.detailData.important_message = res.data.data.important_message;
        this.translateFullText();
      }
    },
    // 翻译摘要（全文）
    async translateFullText() {
      let ts = new Date().getTime();
      let tokenStr = `${this.clientId}.bz${ts}.bz${this.PMID}.bz${this.secret}`;
      let token = md5(tokenStr, 32);
      const params = {
        client_id: this.clientId,
        ts: Number(ts),
        pmid: String(this.PMID),
        types: "cn_full",
        token: token,
      };
      const res = await translateInfo(params);
      if (res.data.status == 0) {
        this.detailData.abstract_en = res.data.data.sentence;
        this.loading = false;
        this.isTranslate = true;
      }
    },
    // 收藏还是取消收藏
    async collection() {
      if (!this.caseData.is_collected) {
        let Logger = webTrackerEvent();
        Logger.push("eventType", "collection_case");
        Logger.push("timeStamp", new Date().getTime());
        Logger.push("patientUid", this.patientUid);
        Logger.push("pageUrl", window.location.href);
        Logger.push("pmid", this.PMID);
        Logger.push("token", this.token);
        Logger.push("openid", this.openid);
        Logger.logger();
        const res = await caseCollect("POST", { patient_uid: this.patientUid });
        if (res.data.status === 0) {
          this.caseData.is_collected = true;
        } else {
          this.$message({
            message: "收藏失败，请重试",
            type: "error",
          });
        }
      } else {
        let Logger = webTrackerEvent();
        Logger.push("eventType", "cancel_collection_case");
        Logger.push("timeStamp", new Date().getTime());
        Logger.push("patientUid", this.patientUid);
        Logger.push("pageUrl", window.location.href);
        Logger.push("pmid", this.PMID);
        Logger.push("token", this.token);
        Logger.push("openid", this.openid);
        Logger.logger();
        const res = await caseCollect("DELETE", { patient_uid: this.patientUid });
        if (res.data.status === 0) {
          this.caseData.is_collected = false;
        } else {
          this.$message({
            message: "取消失败，请重试",
            type: "error",
          });
        }
      }
    },
    // 查看原文
    showOriginText(pmid, link) {
      let Logger = webTrackerEvent();
      Logger.push("page_url", window.location.href);
      Logger.push("action", "originalText");
      Logger.push("pmid", pmid);
      Logger.push("token", this.token);
      Logger.push("openid", this.openid);
      Logger.logger();
      window.open(link);
    },
    // 查看相似病例
    showSimilarCase() {
      let Logger = webTrackerEvent();
      Logger.push("eventType", "viewSimilarCase");
      Logger.push("timeStamp", new Date().getTime());
      Logger.push("pmid", this.PMID);
      Logger.push("patient_uid", this.patientUid);
      Logger.push("pageUrl", window.location.href);
      Logger.push("token", this.token);
      Logger.push("openid", this.openid);
      Logger.logger();
      const { href } = this.$router.resolve({
        name: "similarCase",
        path: "/similarCase",
        query: {
          pmid: this.PMID,
          patientUid: this.patientUid,
          searchType: this.searchType
        },
      });
      window.open(href);
    }
  },
  destroyed () {
    let Logger = webTrackerEvent();
    Logger.push("eventType", "pageUnload");
    Logger.push("timeStamp", new Date().getTime());
    Logger.push("token", this.token);
    Logger.push("openid", this.openid);
    Logger.push("pageUrl", this.currentPageUrl);
    Logger.logger();
  },
  created() {
    this.patientUid = this.$route.query.patientUid;
    this.PMID = this.$route.query.pmid;
    this.searchType = this.$route.query.searchType;
    this.currentPageUrl = window.location.href;
    let Logger = webTrackerEvent();
    Logger.push("eventType", "pageload");
    Logger.push("timeStamp", new Date().getTime());
    Logger.push("token", this.token);
    Logger.push("openid", this.openid);
    Logger.push("pageUrl", window.location.href);
    Logger.logger();

    this.getFullText();
    this.getCaseDetail();
  },
};
</script>

<style scoped lang="less">
/deep/.content .el-loading-mask .el-loading-spinner {
  top: 20% !important;
}
.caseDetail {
  background: #f9f9f9;
  padding-bottom: 50px;
}
.caseDetail .content .fullTitle {
  font-size: 16px;
  color: #4083d4;
}
.caseDetail .content {
  width: 1080px;
  margin: 0 auto;
}
.caseDetail .content .title span {
  margin-left: 18px;
  font-size: 16px;
  font-weight: bold;
  line-height: 34px;
  width: 90%;
}
.caseDetail .content .YXYZ span {
  line-height: 34px;
  margin-left: 10px;
  color: #333;
  font-size: 14px;
}
.caseDetail .content .RGBZ span {
  line-height: 34px;
  margin-left: 10px;
  color: #333;
  font-size: 14px;
}
.caseDetail .content .YXYZ img {
  width: 26px;
  height: 26px;
  margin-top: 5px;
}
.caseDetail .content .RGBZ img {
  width: 22px;
  height: 26px;
  margin-top: 5px;
}
.caseDetail .content .actionRow {
  width: 850px;
  margin: 0 auto;
}
.caseDetail .content p.action a {
  font-size: 14px;
  color: #4183D4;
  padding-left: 24px;
  margin-left: 20px;
  height: 34px;
  border: 1px solid #4183D4;
  display: block;
  border-radius: 20px;
  line-height: 34px;
  text-align: center;
}
.caseDetail .content p.action a.similar {
  width: 84px;
  background: url("../assets/img/icon9.png") no-repeat 10px center;
  background-size: 16px;
}
.caseDetail .content p.action a.original {
  width: 84px;
  background: url("../assets/img/icon8-1.png") no-repeat 10px center;
}
.caseDetail .content p.action a.translate {
  width: 66px;
  background: url("../assets/img/icon1-1.png") no-repeat 14px center;
}
.caseDetail .content p.action a.collection {
  width: 66px;
  background: url("../assets/img/icon3-1.png") no-repeat 10px center;
}
.caseDetail .content p.action a.collectionTrue {
  width: 66px;
  background: url("../assets/img/icon3_01.png") no-repeat 10px center;
}
.caseDetail .content p.action a.share {
  width: 52px;
  background: url("../assets/img/icon4.png") no-repeat 10px center;
}
.caseDetail .content p.action a.download {
  width: 100px;
  background: url("../assets/img/downLoad.png") no-repeat 10px center;
}
.caseDetail .content{
  .case-message-box{
    width: 900px;
    margin: 0 auto;
    margin-top: 30px;
    font-size: 16px;
    color: #333;
    h3{
      font-size: 16px;
    }
    .case-message{
      margin-top: 20px;
      display: flex;
      .patient-message{
        flex: 1;
        margin-left: 10px;
        p{
          margin-bottom: 10px;
          font-size: 14px;
          line-height: 22px;
          span{
            margin-right: 10px;
            word-break: break-all;
          }
          em.title{
            color: #387ed2;
          }
        }
      }
    }
  }
}
.caseDetail .content div.textInfo {
  width: 900px;
  margin: 0 auto;
  margin-top: 30px;
  h3{
    font-size: 16px;
  }
}
.caseDetail .content div.textInfo .el-row {
  border-bottom: 1px dashed #ccc;
  padding: 15px 0;
  font-size: 14px;
  color: #333;
}
.caseDetail .content div.textInfo .el-row span {
  color: #387ed2;
  font-size: 16px;
}
.caseDetail .content div.textInfo .el-row table {
  width: 100%;
  table-layout: fixed;
  border-collapse: collapse;
  margin-top: 20px;
}
.caseDetail .content div.textInfo .el-row table tr th {
  border: 1px solid #ccc;
  background: #fafafa;
  padding: 5px;
}
.caseDetail .content div.textInfo .el-row table tr td {
  border: 1px solid #ccc;
  padding: 5px;
  text-align: center;
}
/deep/.caseDetail .pptDialog {
  border-radius: 12px;
}
.caseDetail .pptDialogContent .item{
  display: flex;
  align-items: center;
}
.caseDetail .pptDialogContent .item:nth-child(1) {
  margin-bottom: 20px;
}
.caseDetail .pptDialogContent .item:nth-child(2) {
  margin-bottom: 20px;
}
.caseDetail .pptDialogContent .item:nth-child(3) {
  margin-bottom: 20px;
}
.caseDetail .pptDialogContent .item .label {
  margin: 0 10px
}
/deep/.caseDetail .pptDialogContent .item .typeSelect .el-radio-button--small .el-radio-button__inner   {
  width: 80px;
}

.caseDetail .pptDialogContent .item .lanSelect {
  width: 240px;
  display: flex;
  justify-content: space-between;
}
.caseDetail .pptDialogContent .item .lanSelect .selectItem  {
  width: 115px;
  height: 30px;
  border: 1px solid #E6E6E6;
  text-align: center;
  line-height: 32px;
  font-size: 12px;
  color: #606266;
  border-radius: 4px;
  cursor: pointer;
}
.caseDetail .pptDialogContent .item .lanSelect .selectItem.lanBtn {
  color: #fff;
  background: #409EFF;
  border-color: #409EFF;
}
.caseDetail .pptDialogContent .item .select {
  width: 240px;
}
.caseDetail .pptDialogContent .templateView {
  padding-left: 47px;
  box-sizing: border-box;
  margin-bottom: 12px;
}
.caseDetail .pptDialogContent .templateView .preview {
  width: 238px;
  border: 1px solid #eee;
}
</style>


// WEBPACK FOOTER //
// src/views/caseDetail.vue